import styled from "styled-components";

import ShowWeather from "./ShowWeather";

import axios from "axios";
import React, { useState } from "react";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
  padding: 20px;
  place-content: center;
  width: 220px;
`;

const WeatherLogoContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const WeatherLogo = styled.img`
  heigth: 10rem;
  width: 13rem;
  object-fit: contain;
`;

const SearchForm = styled.form`
  display: flex;
  flex-direction: row;
  border: 2px solid black;
  margin: 20px 0px;
  justify-content: space-between;
  & input {
    border: none;
    outline: none;
    width: 8rem;
  }
  & button {
    background: rgb(148, 77, 130);
    color: white;
    font-size: 20px;
  }
`;

const FindCityText = styled.div`
  font-size: 18px;
  font-weight: bold;
  display: flex;
  display: flex;
  text-align: center;
  justify-content: center;
  padding: 10px 0px;
`;

const ErrorMessage = styled.span`
  font-size: 20px;
  font-weight: bold;
  display: flex;
  text-align: center;
  justify-content: center;
  padding: 10px 0px;
  color: red;
`;
const SearchWeather = (props) => {
  const [city, setCity] = useState("");
  const [error, setError] = useState("");
  const [weather, updateWeather] = useState();

  const fetchWeather = (e) => {
    e.preventDefault();
    axios
      .get(
        `https://api.openweathermap.org/data/2.5/weather/?q=${city}&appid=8133d5dc7376448ce28f842f6bfef66b`
      )
      .then((res) => {
        console.log("res", res);
        updateWeather(res?.data);
        setError("");
      })
      .catch((error) => {
        console.log("err", error);
        setError("City not found");
        updateWeather("");
      });
  };

  return (
    <Container>
      {weather ? (
        <ShowWeather weather={weather} />
      ) : error ? (
        <ErrorMessage> {error} </ErrorMessage>
      ) : (
        <WeatherLogoContainer>
          <WeatherLogo src="icons/weather.jpg" />
        </WeatherLogoContainer>
      )}
      <FindCityText>Find Weather of your City</FindCityText>
      <SearchForm onSubmit={fetchWeather}>
        <input
          type="text"
          placeholder="city"
          name="city"
          autocomplete="off"
          onChange={(e) => {
            setCity(e.target.value);
          }}
        />
        <button>Search</button>
      </SearchForm>
    </Container>
  );
};

export default SearchWeather;
